import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import FetchUtil from "../../utils/FetchUtil";
import { emptyCache } from "../../utils/helper.js";
import { useTranslation } from 'react-i18next';

function Logoff() {
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const userCtx = useContext(UserContext);
	const { t } = useTranslation();

	useEffect(() => {
		if (confirm(t("page.confirmationMessage"))) {
			userCtx.addUserName("");
			userCtx.addLoggedInUserId("");
			userCtx.addRole("");
			userCtx.addIsAuthenticated(false);
			userCtx.clearStorage();
			userCtx.addEnabledMFA(0);
			const requestOptions = {
				credentials: "same-origin",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ "source": "web" }),
			};

			try {
				FetchUtil.fetchAPI("Logoff", "/Service/UserService/Logoff", requestOptions, logoffSuccess, logoffFail);
			} catch (error) {
				setError(error.message);
				navigate("/", {
					state: {
						errorMessage: t("error.error") + " " + error.message,
					},
				});
			}
		} else {
			navigate("/pages/landing");
		}

		function logoffFail(redirect) {
			emptyCache();
			navigate("/", {
				state: {
					errorMessage: "",
				},
			});
		}
		function logoffSuccess(responseData) {
			console.log("LogoffSuccess");
			emptyCache();
			let logOffResponse;
			if (responseData) {
				logOffResponse = responseData.logOffResponse;
				if (logOffResponse && logOffResponse.errorCode === "0") {
					userCtx.addUserName("");
					userCtx.addLoggedInUserId("");
					userCtx.addRole("");
					userCtx.addIsAuthenticated(false);
					userCtx.clearStorage();
					userCtx.addEnabledMFA(0);
					
					let logoutWindow = window.open("https://idecisionsciences.awsapps.com/start#/signout", "_newwin", "width=100,height=100");
					window.setTimeout(
						() => {
							logoutWindow.close();
							if (logoutWindow.closed) {
								navigate("/", {
									state: {
										errorMessage: "",
									},
								});
							}
						},
						500
					);

				} else if (logOffResponse && logOffResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else if (logOffResponse) {
					setError(t("error.error") + " " + logOffResponse.errorMessage);
					navigate("/", {
						state: {
							errorMessage: "",
						},
					});
				} else {
					navigate("/", {
						state: {
							errorMessage: "",
						},
					});
				}
			} else {
				setError(t("error.error"));
				navigate("/", {
					state: {
						errorMessage: "",
					},
				});
			}
		}

	}, []);

	return (
		<div className="container">
			<div className="row">
				<div className="col">
					<div
						id="inerrorMessage"
						className={
							error
								? "errorblock"
								: "errorblock hide"
						}
					>
						{error}
					</div>
				</div>
			</div>
		</div>
	);
}
export default Logoff;